import { useIsAdmin } from "@src/api/user-auths/is-admin";

/**
 * Whether the app points this user to the audit. Discoverability only, and
 * deliberately not access: the route stays open so anyone holding the link can
 * reach the audit while it is being built. `useIsAdmin` is undefined until the
 * user resolves, so a merchant never sees a pointer flash before it disappears.
 */
export const useCanSeeOpportunityAudit = (): boolean => useIsAdmin() === true;
